/* ===================================================================
   MOBILE BG FIX — 2026-05-23
   Stale Fastly CDN nodes may serve old index.json rendering that sets
   background_image_mobile to Vital-Origin-1500x1500-02-1-scaled.jpg
   (green Beef Kidney infographic) instead of shop-by-benefits-mobile.png.
   This patch runs before lazy images load and swaps the wrong <source>
   srcset to the correct brown mobile background.
   Self-limiting: no-op once CDN propagates correct HTML.
   =================================================================== */
(function () {
  var WRONG = 'Vital-Origin-1500x1500-02-1-scaled';
  var CORRECT = 'https://cdn.shopify.com/s/files/1/0774/1548/1572/files/shop-by-benefits-mobile.png?v=1765986345';
  function fixMobileBg() {
    document.querySelectorAll('picture source[media]').forEach(function (src) {
      var m = src.getAttribute('media') || '';
      var s = src.getAttribute('srcset') || '';
      if (m.indexOf('749px') !== -1 && s.indexOf(WRONG) !== -1) {
        src.setAttribute('srcset', CORRECT);
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixMobileBg);
  } else {
    fixMobileBg();
  }
})();

/* ===================================================================
   BUNDLER + SEAL — DEFAULT TO SUBSCRIBE (v2, 2026-10-29)
   Replaces the 2026-05-21 8-second poller (which clicked Seal's Subscribe radio).

   Why: Bundler's "Always turn subscriptions on" setting is false, and our CSS hides
   Bundler's own "Subscribe & Save" checkbox. Bundler only shows Seal's widget (it
   sets it display:none) when that checkbox is ticked, and it reverts any Seal
   selection back to One-time while the checkbox is unticked. So Subscribe could
   not be picked and the whole selector stayed invisible. Bundler also renders its
   widget lazily (when the form scrolls into view), usually after the old poller had
   already given up — hence the "flaky" selector.

   Fix: whenever Seal (re)creates its widget inside Bundler's container, tick that
   checkbox and fire its change event — exactly what "Always turn subscriptions on"
   does. The widget becomes visible with Subscribe selected; One-time stays one
   click away. A deliberate One-time pick is respected across re-renders.
   Idempotent: a no-op once the setting is switched on in Bundler admin.
   =================================================================== */
(function () {
  var userChoseOneTime = false;
  var pending = null;

  document.addEventListener('click', function (e) {
    if (!e.isTrusted || !e.target || !e.target.closest) return;
    var opt = e.target.closest('.bndlr-subscription-container .sls-option-container');
    var input = opt && opt.querySelector('input.sls-option');
    if (input) userChoseOneTime = input.getAttribute('data-type') !== 'subscription';
  }, true);

  function enable() {
    if (userChoseOneTime) return;
    var boxes = document.querySelectorAll('.bndlr-subscription-container .bndlr-subscription-checkbox');
    for (var i = 0; i < boxes.length; i++) {
      var cb = boxes[i];
      var wrap = cb.closest('.bndlr-subscription-container').querySelector('.sealsubs-target-element');
      if (!wrap) continue;
      if (cb.checked && wrap.style.display !== 'none') continue;
      cb.checked = true;
      cb.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function schedule(delay) {
    clearTimeout(pending);
    pending = setTimeout(enable, delay);
  }

  /* Bundler binds the checkbox's change handler inside its own listener for this event,
     which runs after ours — so wait for the dispatch to finish before ticking. */
  document.addEventListener('sealsubs:subscription_widget_created', function () {
    [100, 300, 600, 1200].forEach(function (ms) { setTimeout(enable, ms); });
  });

  /* Safety net: Bundler re-renders on variant/tier changes; catch any state the event misses. */
  function watch() {
    new MutationObserver(function () {
      if (document.querySelector('.bndlr-subscription-container')) schedule(1500);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.body) watch();
  else document.addEventListener('DOMContentLoaded', watch);
})();
